import { LocalTransportPricing } from '../../lib/types/models/local-transport-pricing/local-transport-pricing'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterLocalTransport(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterLocalTransport.url, { id }))
    .get<LocalTransportPricing>()
}
